import * as R from 'ramda'
import React from 'react'
import { Button } from 'semantic-ui-react'
import styled from 'styled-components'
import { getParticipants } from '../api/async/participants/index'
import { formatDateTime } from '../utils/index'

const StyledCard = styled.div.attrs({
  className: 'ui centered stackable card'
})`
  && {
    width: 80%;
  }
`

class ThankYou extends React.Component {
  state = {
    participant: {}
  }
  componentDidMount() {
    getParticipants({ id: this.props.match.params.id }).then(res =>
      this.setState({ participant: res.data[0] })
    )
  }
  render() {
    const { participant } = this.state
    return (
      <React.Fragment>
        <StyledCard>
          <div className="image">
            <img
              src={R.pathOr(
                R.path(['race_detail', 'race', 'feature_image'], participant),
                ['bib'],
                participant
              )}
            />
          </div>
          <div className="content">
            <div style={{ textAlign: 'center', marginBottom: 10 }}>
              <a
                href={R.pathOr(
                  R.path(['race_detail', 'race', 'feature_image'], participant),
                  ['bib'],
                  participant
                )}
                download
              >
                <Button size="big" color="teal" className="mt10">
                  Download
                </Button>
              </a>
            </div>
            <div className="description">
              <p>
                ยินดีด้วยค่าา การสมัครงานวิ่ง / เดิน{' '}
                {R.path(['race_detail', 'race', 'title'], participant)}{' '}
                ของคุณเรียบร้อยแล้ว
              </p>
              <p>
                <span style={{ fontWeight: 'bold' }}>เริ่มออกวิ่งวันที่</span>:{' '}
                {`${formatDateTime(
                  R.path(['race_detail', 'race', 'start_time'], participant)
                )} - ${formatDateTime(
                  R.path(['race_detail', 'race', 'end_time'], participant)
                )}`}
              </p>
              <p>
                <span style={{ marginTop: '5', fontWeight: 'bold' }}>
                  เริ่มส่งผลวิ่ง / เดินวันที่:{' '}
                </span>
                {`${formatDateTime(
                  R.path(['race_detail', 'race', 'start_time'], participant)
                )} - ${formatDateTime(
                  R.path(
                    ['race_detail', 'race', 'last_submit_time'],
                    participant
                  )
                )}`}
              </p>
              <p>
                <span style={{ marginTop: '5', fontWeight: 'bold' }}>
                  วันส่งผลการแข่งขัน:{' '}
                </span>
                {`${formatDateTime(
                  R.path(['race_detail', 'race', 'start_time'], participant)
                )} - ${formatDateTime(
                  R.path(
                    ['race_detail', 'race', 'last_submit_time'],
                    participant
                  )
                )}`}
              </p>
            </div>
          </div>
        </StyledCard>
      </React.Fragment>
    )
  }
}

export default ThankYou



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Thankyou.js